/* eslint-disable @typescript-eslint/camelcase */
import { Grid, makeStyles, Tab, Tabs } from '@material-ui/core';
import i18n from 'i18n';
import {
  CompanyData,
  PermissionsData,
  RolesEnum,
} from 'modules/authenticate/interfaces';
import { ListClientDataSessionProps } from 'modules/clients/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import clsx from 'clsx';
import { inAdminView, inSuperAdminView, inOperatorView } from 'utils/role';
import ClientsTemplate from '../Templates/Clients';
import styles from './styles';
import SessionHistory from './SessionHistory';
import SessionContainer from './SessionContainer';
import TabPanel from './TabPanel';

const useStyles = makeStyles(styles);

interface Props {
  isLoading: boolean;
  listSessionClients: ListClientDataSessionProps;
  role?: RolesEnum;
  companySelected: CompanyData | null;
  permissions: PermissionsData | undefined;
}

const SessionClients = ({ permissions, role, companySelected }: Props) => {
  const classes = useStyles();

  const [currentTab, setCurrentTab] = React.useState(
    !permissions?.list_client_instance_sessions &&
      !permissions?.list_environment_instance_sessions
      ? 1
      : 0
  );

  return (
    <ClientsTemplate
      current="sessions"
      title={i18n.t('CLIENTS_PAGE.LIST_SESSIONS_TITLE_KEY')}
      breadcrumbs={[
        {
          name: i18n.t('CLIENT_KEY'),
          link: '/clients',
        },
        {
          name: i18n.t('SESSIONS_KEY'),
        },
      ]}
    >
      <Grid container className={classes.rootTabs}>
        <Tabs
          value={currentTab}
          onChange={(e, newValue) => setCurrentTab(newValue)}
          className={clsx({
            [classes.tabsGreen]: inAdminView(role, companySelected),
            [classes.tabsGray]: inSuperAdminView(role, companySelected),
            [classes.tabsBlue]: inOperatorView(role, companySelected),
            [classes.tabsYellow]: companySelected,
          })}
        >
          <Tab
            disabled={
              !permissions?.list_client_instance_sessions &&
              !permissions?.list_environment_instance_sessions
            }
            id="btn-general"
            label={i18n.t('CLIENTS_PAGE.LIST_SESSIONS_TITLE_KEY')}
            className={clsx({
              [`${classes.tabGreen} ${classes.tab}`]: inAdminView(
                role,
                companySelected
              ),
              [`${classes.tabGray} ${classes.tab}`]: inSuperAdminView(
                role,
                companySelected
              ),
              [`${classes.tabBlue} ${classes.tab}`]: inOperatorView(
                role,
                companySelected
              ),
              [`${classes.tabYellow} ${classes.tab}`]: companySelected,
            })}
          />
          <Tab
            disabled={!!permissions && !permissions.list_session_history}
            id="btn-general"
            label={i18n.t('CLIENTS_PAGE.SESSION_HISTORY_KEY')}
            className={clsx({
              [`${classes.tabGreen} ${classes.tab}`]: inAdminView(
                role,
                companySelected
              ),
              [`${classes.tabGray} ${classes.tab}`]: inSuperAdminView(
                role,
                companySelected
              ),
              [`${classes.tabBlue} ${classes.tab}`]: inOperatorView(
                role,
                companySelected
              ),
              [`${classes.tabYellow} ${classes.tab}`]: companySelected,
            })}
          />
        </Tabs>
      </Grid>
      <Grid className={classes.content}>
        <Grid container>
          <TabPanel value={currentTab} index={0}>
            <SessionContainer />
          </TabPanel>

          <TabPanel value={currentTab} index={1}>
            <SessionHistory />
          </TabPanel>
        </Grid>
      </Grid>
    </ClientsTemplate>
  );
};

const mapStateToProps = ({
  authenticate: { data, companySelected },
  clients: { isLoading },
}: ApplicationState) => ({
  isLoading,
  companySelected,
  permissions: data?.permissions,
  role: data?.role,
});

export default connect(mapStateToProps, {})(SessionClients);
